import { faCheck, faExclamation, faFileCsv, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { api_GET } from "services/api_service";
import { showMessage } from "services/message";
import moment from "moment";
import { api_POST } from "services/api_service";

export function StatusOperacionaisTable({ periodo, concessionariaId, regionaisId, modalidadeColetaId }) {
  const [expandedRows, setExpandedRows] = useState({});
  const [visibleTables, setVisibleTables] = useState({});
  const [pontoColetaData, setPontoColetaData] = useState({});
  const [showLoading, setShowLoading] = useState(false);

  const [orderBy, setOrderBy] = useState("percentual");
  const [orderDirection, setOrderDirection] = useState("desc");

  // Estado para data selecionada
  const [dataSelecionada, setDataSelecionada] = useState(null);
  const [intervaloDatas, setIntervaloDatas] = useState([]);
  const [dadosStatusOperacional, setDadosStatusOperacional] = useState([]);
  const [csvMode, setCsvMode] = useState("Simples");

  const carregarDadosStatusOperacional = async (data) => {
    const json_post = {
      inicio: data,
      fim: data,
      concessionariaId: concessionariaId,
      regionaisId: regionaisId,
      modalidadeColetaId: modalidadeColetaId
    };

    setShowLoading(true);

    api_POST('dashboard/statusoperacional', json_post).then(result => {
      setShowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      } else {
        setDadosStatusOperacional(result.data || []);
      }
    }).catch(error => {
      setShowLoading(false);
      showMessage("Erro", "Erro ao carregar dados do Status Operacional", 'error', null);
    });
  };

  // Função para gerar array de datas entre início e fim
  const gerarIntervaloDatas = (dataInicio, dataFim) => {
    const datas = [];
    const inicio = moment(dataInicio);
    const fim = moment(dataFim);

    while (inicio.isSameOrBefore(fim)) {
      datas.push(inicio.format('YYYY-MM-DD'));
      inicio.add(1, 'days');
    }

    return datas;
  };


  const toggleRow = (regionalIndex, setorIndex) => {
    const key = `${regionalIndex}-${setorIndex}`;
    setExpandedRows(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const toggleTable = (regionalIndex) => {
    setVisibleTables(prev => ({
      ...prev,
      [regionalIndex]: !prev[regionalIndex]
    }));
  };

  const statusColors = {
    'Não Programada': 'text-secondary',
    'Não Programado': 'text-muted',
    'Programada': 'text-danger',
    'Programado': 'text-danger',
    'Em Execução': 'text-primary',
    'Em Pausa': 'text-muted',
    'Destinada': 'text-warning',
    'Finalizada': 'text-success',
    'Finalizado': 'text-success',
    'Não Executada': 'text-danger'
  }

  function loadPontoColetasBySetor(objConsulta = {}) {
    const key = `${objConsulta.regionalIndex}-${objConsulta.setorIndex}`;

    if (pontoColetaData[key]) {
      toggleRow(objConsulta.regionalIndex, objConsulta.setorIndex);
      return;
    }

    setShowLoading(true);

    const dataFiltro = dataSelecionada || periodo?.dataInicio;

    api_GET(`PontoColeta/GetListByFiltros/${objConsulta.setorColetaId}/${dataFiltro}/${dataFiltro}/Programada`).then(result => {
      setShowLoading(false);

      if (result.status !== 200) {
        return showMessage("Aviso", result.message, 'error', null);
      }

      setPontoColetaData(prev => ({
        ...prev,
        [key]: result.data
      }));

      toggleRow(objConsulta.regionalIndex, objConsulta.setorIndex);
    });
  }

  const exportStatusOperacionaisCsv = () => {
    if (!dadosStatusOperacional || dadosStatusOperacional.length === 0) return;
    const header = [
      "Regional",
      "Data da Programação",
      "Setor",
      "Placa",
      "Operador",
      "Situação",
      "Plano de Trabalho",
      "Executado",
      "Avulso",
      "Pendentes",
      "Percentual",
      "Pesagens",
      "Peso Médio"
    ];
    const rows = [];
    dadosStatusOperacional.forEach(regional => {
      const regionalName = regional?.regional ?? "";
      (regional?.setores || []).forEach(s => {
        const isTotal = String(s?.setor ?? "").trim() === "Total";
        if (csvMode === "Simples" && !s.principal && !isTotal) return;

        // Normaliza campos
        const pesagens = s?.pesagensLiquidos ?? "";
        rows.push([
          (String(s?.setor ?? "").trim() === "Total") ? "Total" : (regionalName ?? ""),
          s?.dataOrdem ?? "",
          (String(s?.setor ?? "").trim() === "Total") ? "" : (s?.setor ?? ""),
          s?.placa ?? "",
          s?.operador ?? "",
          s?.situacao ?? "",
          s?.planoTrabalho ?? "",
          s?.executado ?? "",
          s?.avulso ?? "",
          s?.pendentes ?? "",
          s?.percetual ?? "",
          String(pesagens).replace(/\r?\n/g, " / "),
          s?.pesoMedio ?? ""
        ]);
      });
    });

    const escapeCsv = (val) => {
      const v = val == null ? "" : String(val);
      const escaped = v.replace(/"/g, '""');
      return (escaped.includes(",") || escaped.includes('"') || escaped.includes("\n")) ? `"${escaped}"` : escaped;
    };

    const csvContent = "\uFEFF" + [header, ...rows].map(r => r.map(escapeCsv).join(",")).join("\r\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `status_operacionais_${new Date().toISOString().replace(/[:.]/g, '-')}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    if (dadosStatusOperacional.length > 0) {
      const initialState = {};

      dadosStatusOperacional.forEach((_, index) => {
        initialState[index] = true;
      });

      setVisibleTables(initialState);
    }
  }, [dadosStatusOperacional]);

  useEffect(() => {
    if (periodo?.dataInicio && periodo?.dataFim) {
      const datas = gerarIntervaloDatas(periodo.dataInicio, periodo.dataFim);
      setIntervaloDatas(datas);

      if (datas.length > 0) {
        setDataSelecionada(datas[0]);
      }
    }
  }, [periodo]);

  useEffect(() => {
    if (dataSelecionada) {
      setPontoColetaData({});
      setExpandedRows({});
      carregarDadosStatusOperacional(dataSelecionada);
    }
  }, [dataSelecionada, concessionariaId, regionaisId, modalidadeColetaId]);

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <label style={{ marginRight: "20px" }}>Carregando...</label>
            <Spinner size="sm" color="info" />
          </div>
        </div>
      }
      <div className="card shadow mt-2">
        <div className="d-flex flex-wrap align-items-center justify-content-between pl-4 pr-4 pt-3 mb-3">
          <h3 className="mb-0 text-dark">Status Operacionais</h3>

          <div className="d-flex align-items-center">
            {/* Ordenação */}
            <div className="d-flex align-items-center mr-4">
              <label className="mb-0 mr-2 font-weight-bold text-muted small">Ordenar por:</label>
              <select
                className="form-control form-control-sm w-auto mr-2"
                value={orderBy}
                onChange={e => {
                  setOrderBy(e.target.value);
                  if (e.target.value === "status") setOrderDirection("Finalizado");
                  else setOrderDirection("desc");
                }}
              >
                <option value="percentual">Percentual</option>
                <option value="status">Status</option>
              </select>
              <select
                className="form-control form-control-sm w-auto"
                value={orderDirection}
                onChange={e => setOrderDirection(e.target.value)}
              >
                {orderBy === "status" ? (
                  <>
                    <option value="Não Programado">Não Programado</option>
                    <option value="Em Execução">Em Execução</option>
                    <option value="Finalizado">Finalizado</option>
                    <option value="Programado">Programado</option>
                  </>
                ) : (
                  <>
                    <option value="asc">Crescente</option>
                    <option value="desc">Decrescente</option>
                  </>
                )}
              </select>
            </div>

            {/* Exportação */}
            <div className="d-flex align-items-center border-left pl-4">
              <select
                className="form-control form-control-sm w-auto mr-2"
                value={csvMode}
                onChange={(e) => setCsvMode(e.target.value)}
              >
                <option value="Simples">Simples</option>
                <option value="Completo">Completo</option>
              </select>
              <button className="btn btn-sm btn-outline-success d-flex align-items-center" onClick={exportStatusOperacionaisCsv} title="Exportar CSV">
                <FontAwesomeIcon icon={faFileCsv} className="mr-2" /> CSV
              </button>
            </div>
          </div>
        </div>

        {/* Seletor de Data */}
        <div className="px-4 pb-3">
          <label className="form-control-label font-weight-bold mb-2">Selecione a Data:</label>
          <div className="d-flex flex-wrap gap-2" style={{ gap: '8px' }}>
            {intervaloDatas.map((data, index) => {
              const numeroDia = moment(data).format('D');
              const estaSelecionada = dataSelecionada === data;

              return (
                <button
                  key={index}
                  className={`btn btn-sm ${estaSelecionada ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setDataSelecionada(data)}
                  style={{
                    minWidth: '40px',
                    height: '40px',
                    padding: '8px',
                    fontWeight: estaSelecionada ? 'bold' : 'normal',
                    margin: '2px'
                  }}
                  title={moment(data).format('DD/MM/YYYY')}
                >
                  {numeroDia}
                </button>
              );
            })}
          </div>
          {dataSelecionada && (
            <small className="text-muted mt-2 d-block">
              Data selecionada: {moment(dataSelecionada).format('DD/MM/YYYY')}
            </small>
          )}
        </div>

        {dadosStatusOperacional.map((regionalData, regionalIndex) => {
          // Ordena os setores conforme seleção
          let setoresOrdenados = [...regionalData.setores];

          const parsePercent = (valor) => {
            if (!valor) return 0;
            return parseFloat(valor.replace('%', '').trim()) || 0;
          };

          const setorTotal = setoresOrdenados.find(s => s.setor === "Total");

          const principais = setoresOrdenados.filter(s => s.principal);
          const filhas = setoresOrdenados.filter(s => !s.principal && s.setor !== "Total");

          let principaisOrdenados = [...principais];

          if (orderBy === "percentual") {
            principaisOrdenados = orderDirection === "asc"
              ? principaisOrdenados.sort((a, b) => parsePercent(a.percetual) - parsePercent(b.percetual))
              : principaisOrdenados.sort((a, b) => parsePercent(b.percetual) - parsePercent(a.percetual));
          }
          else if (orderBy === "status") {
            principaisOrdenados = principaisOrdenados.filter(
              p => p.situacao === orderDirection
            );
          }

          let novaLista = [];

          principaisOrdenados.forEach(principal => {
            novaLista.push(principal);

            const filhasDoPrincipal = filhas.filter(f =>
              f.setorColetaId === principal.setorColetaId &&
              f.regionalId === principal.regionalId &&
              f.setor !== "Total"
            );

            novaLista.push(...filhasDoPrincipal);
          });

          if (setorTotal) novaLista.push(setorTotal);

          return (
            <div key={regionalIndex} className="mb-2">
              <h4
                className="text-dark text-center p-1 rounded cursor-pointer"
                onClick={() => toggleTable(regionalIndex)}
                style={{ cursor: 'pointer' }}
              >
                {regionalData.regional}
              </h4>

              {visibleTables[regionalIndex] && <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                  <thead className="thead-light">
                    <tr >
                      <th style={{ width: '20px' }} className="no-print"></th>
                      <th style={{ width: '120px', wordWrap: 'break-word', whiteSpace: 'normal' }}>Data da Programação</th>
                      <th style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>Setor</th>
                      <th style={{ width: '120px', wordWrap: 'break-word', whiteSpace: 'normal' }}>Placa</th>
                      <th style={{ width: '180px', wordWrap: 'break-word', whiteSpace: 'normal' }}>Operador</th>
                      <th style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>Situação</th>
                      <th style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>Plano de Trabalho</th>
                      <th style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>Executado</th>
                      <th style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>Avulso</th>
                      <th style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>Pendentes</th>
                      <th style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>Percentual</th>
                      <th>Pesagens</th>
                      <th>Peso Médio</th>
                    </tr>
                  </thead>
                  <tbody>
                    {novaLista.map((setor, setorIndex) => {
                      const rowKey = `${regionalIndex}-${setorIndex}`;
                      const isExpanded = expandedRows[rowKey];

                      return (
                        <React.Fragment key={setorIndex}>
                          <tr>
                            <td style={{ width: '20px' }} className="no-print">
                              {setor.setor != "Total" && setor.principal == true &&
                                <button
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => {
                                    const key = `${regionalIndex}-${setorIndex}`;
                                    if (!expandedRows[key]) {
                                      loadPontoColetasBySetor({
                                        regionalId: regionalData.regionalId,
                                        regionalIndex: regionalIndex,
                                        setorIndex: setorIndex,
                                        setorColetaId: setor.setorColetaId
                                      });
                                    } else {
                                      toggleRow(regionalIndex, setorIndex);
                                    }
                                  }}
                                >
                                  {isExpanded ? '-' : '+'}
                                </button>
                              }
                            </td>
                            <td style={{ width: '120px', wordWrap: 'break-word', whiteSpace: 'normal' }}>{setor.dataOrdem}</td>
                            <td style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>{setor.setor}</td>
                            <td style={{ width: '120px', wordWrap: 'break-word', whiteSpace: 'normal' }}>{setor.placa}</td>
                            <td style={{ width: '180px', wordWrap: 'break-word', whiteSpace: 'normal' }}>{setor.operador}</td>
                            <td style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                              <span className={`${statusColors[setor.situacao] || 'bg-secondary'}`}>
                                {setor.situacao}
                              </span>
                            </td>
                            <td style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>{setor.planoTrabalho != null ? setor.planoTrabalho : ""}</td>
                            <td style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>{setor.executado}</td>
                            <td style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>{setor.avulso}</td>
                            <td style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}> {setor.pendentes}</td>
                            <td style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                              <div
                                className={`d-flex align-items-center ${setor.icone === "vermelho"
                                  ? "text-danger"
                                  : setor.icone === "amarelo"
                                    ? "text-warning"
                                    : "text-success"
                                  }`}
                              >
                                <FontAwesomeIcon
                                  icon={
                                    setor.icone === "vermelho"
                                      ? faTimes
                                      : setor.icone === "amarelo"
                                        ? faExclamation
                                        : !setor.icone ? "" : faCheck
                                  }
                                  className="mr-2"
                                />
                                {setor.percetual}
                              </div>
                            </td>
                            <td >
                              <div style={{ maxWidth: '100%', wordWrap: 'break-word' }}>
                                {setor.pesagensLiquidos?.length > 0 ? (
                                  setor.pesagensLiquidos
                                    .split(" / ")
                                    .reduce((acc, curr, i) => {
                                      const index = Math.floor(i / 7);
                                      acc[index] = acc[index] ? [...acc[index], curr] : [curr];
                                      return acc;
                                    }, [])
                                    .map((linha, i) => (
                                      <div key={i}>{linha.join(" / ")}</div>
                                    ))
                                ) : (
                                  "0"
                                )}
                              </div>
                            </td>
                            <td style={{ width: '80px', wordWrap: 'break-word', whiteSpace: 'normal' }}> {setor.pesoMedio}</td>
                          </tr>

                          {isExpanded && (
                            <tr>
                              <td colSpan="11" className="text-muted">
                                <div className="p-2">
                                  {pontoColetaData[rowKey] ? (
                                    pontoColetaData[rowKey].map((ponto, idx) => (
                                      <div key={idx} className="mb-2 ">
                                        <strong>{setor.setor} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {ponto.descricao}</strong>
                                      </div>
                                    ))
                                  ) : (
                                    <span >Carregando...</span>
                                  )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>}
            </div>
          );
        })}
      </div>
    </>
  );
};
